"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoltAmpere = exports.HorsePower = exports.KiloBtuPerHour = exports.TonCooling = exports.BtuPerHour = exports.GigaWatt = exports.MegaWatt = exports.KiloWatt = exports.Watt = void 0;
var uom_1 = require("uom");
exports.Watt = uom_1.UnitFormat.createUnitFormat("W", 2);
exports.KiloWatt = uom_1.UnitFormat.createUnitFormat("kW", 2);
exports.MegaWatt = uom_1.UnitFormat.createUnitFormat("MW", 0);
exports.GigaWatt = uom_1.UnitFormat.createUnitFormat("GW", 0);
exports.BtuPerHour = uom_1.UnitFormat.createUnitFormat("BTU/h", 0);
exports.TonCooling = uom_1.UnitFormat.createUnitFormat("tons", 2);
exports.KiloBtuPerHour = uom_1.UnitFormat.createUnitFormat("MBH", 1);
exports.HorsePower = uom_1.UnitFormat.createUnitFormat("hp", 1);
exports.VoltAmpere = uom_1.UnitFormat.createUnitFormat("VA", 2);
//# sourceMappingURL=power-format.js.map